import { MatrixModel, RoleModel } from "../../types";

import { MATRIX_SERVICE } from "../../../../../api/Matrix";
import { useQuery } from "@tanstack/react-query";

export const matrixKeys = {
  getMatrix: "matrix",
  gerRoles: "roles",
};

const mappingRoleDataFromServer = (data: RoleModel[]) => {
  if (!data?.length) {
    return data;
  }
  return [{ id: 0, name: "Право" }, ...data];
};

export const useGetPermissionsMatrix = (searchText: string) => {
  return useQuery<MatrixModel[]>({
    queryKey: [matrixKeys.getMatrix, searchText],
    queryFn: MATRIX_SERVICE.getMatrix,
  });
};

export const getListOfRoles = (search: string) => {
  return useQuery<RoleModel[]>({
    queryKey: [matrixKeys.gerRoles, search],
    queryFn: MATRIX_SERVICE.getListOfRoles,
    keepPreviousData: true,
    select: mappingRoleDataFromServer,
  });
};
